export const PRODUCT_CONFIG = {
  PRODUCT_CHART_LOADING_CLASS: "performance-chart--loading",
  PRODUCT_FILTER_ACTIVE_CLASS: "performance__filter--active",
};

export const config = {
  performanceChartContainerSelector: "#performanceChartContainer",
  chart: "#performanceChart",
  filters: "#performanceFilters",
  datepicker: "#performanceDatepickerInstance",
};

export const COLORS = {
  COLOR_1:
    getComputedStyle(document.body).getPropertyValue(
      "--performance-chart--color-0"
    ) || "#191996",
  COLOR_2:
    getComputedStyle(document.body).getPropertyValue(
      "--performance-chart--color-1"
    ) || "#9BB4FA",
  COLOR_3:
    getComputedStyle(document.body).getPropertyValue(
      "--performance-chart--color-2"
    ) || "#9BB4FA",
};

export const CHART_COLORS_BASED_ON_INDEX = [
  COLORS.COLOR_1,
  COLORS.COLOR_2,
  COLORS.COLOR_3,
];

export const chartStyles = {
  responsive: true,
  maintainAspectRatio: false,
  options: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    scales: {
      xAxis: {
        ticks: {
          maxTicksLimit: 6,
          maxRotation: 0,
          minRotation: 0,
        },
      },
      yAxis: {
        ticks: {},
      },
    },
  },
};
